import { ElMessage } from 'element-plus';

export function useMessageSuccess() {
  const open = (message) => {
    ElMessage.success({
      message,
      showClose: true,
      duration: 6000,
    });
  };
  return { open };
}
